let goodstone = {

    init: function () {
        // this.register_plugin();
        // this.gsap_config();
        // this.lenis_with_scrolltrigger();
        this.slick_carousel();
        this.accordion();
        this.send_ring_sizer();
    },
    register_plugin: () => {
        gsap.registerPlugin(ScrollTrigger);
    },
    gsap_config: () => {
        gsap.config({
            trialWarn: false,
            ease: 'power1.inOut'
        });
    },
    lenis_with_scrolltrigger: () => {
        const lenis = new Lenis();
        lenis.on('scroll', (e) => {
            ScrollTrigger.update;
        });
        gsap.ticker.add((time) => {
            lenis.raf(time * 1000);
        })
        gsap.ticker.lagSmoothing(0);
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
    },
    register_custom_component: function () {
        class SlickSlider extends HTMLElement {
            constructor() {
                super();
            }
        };
        customElements.define('slick-slider', SlickSlider);
    },
    slick_carousel: function () {
         $(document).ready(function() {
            var $announcements = $('[data-slider="announcements"]');
            var announcementsContent = $announcements.html();
            
            // Duplicate the announcements to ensure seamless looping
            $announcements.append(announcementsContent);
        
            $announcements.slick({
                arrows: false,
                dots: false,
                variableWidth: true,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 10000,
                cssEase: 'linear',
                infinite: true,
                pauseOnHover: false
            });
        });


        let related_products_slider = $('[data-slider="related-products"]');
        related_products_slider.slick({
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><p class="sr-only">Previous</p><svg width="19" height="17"><use href="#icon--slider-arrow" /></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><p class="sr-only">Previous</p><svg width="19" height="17"><use href="#icon--slider-arrow" /></svg></button>',
            dots: true,
            autoplay: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            draggable: false,
            appendArrows: $('.nav--related-products'),
            appendDots: $('.nav--related-products'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                        centerPadding: '14rem',
                    }
                }
            ]
        });

      let shapes_slider = $('[data-slider="shop-by-shape"]');
      shapes_slider.slick({
            arrows: false,
            dots: false,
            autoplay: false,
            // variableWidth: true,
            slidesToShow: 10,
            slidesToScroll: 1,
            infinite: false,
            responsive: [
              {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 6,
                      swipeToSlide: true
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 5,
                      swipeToSlide: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                      swipeToSlide: true
                    }
                }
            ]
        });
    },
    tabs: function () {
        $('[data-tabination="detailed-specs"]').responsiveTabs({
            startCollapsed: 'accordion'
        });
    },
    accordion: function () {
        // Keep aria-expanded on the header button in step with the panel. The
        // header is a <button> inside a heading, so Enter and Space already
        // activate it natively; nothing here binds keys.
        function syncAria($item) {
            var open = $item.hasClass('active');
            $item.find('button.accordion__head').attr('aria-expanded', String(open));
        }

        $('.accordion__item').each(function () {
            if ($(this).hasClass('active')) {
                $(this).find('.accordion__body').slideToggle();
            }
            syncAria($(this));
        });

        $('.accordion__head').on('click', function () {
            // The header now sits inside a heading wrapper, so the item is an
            // ancestor rather than the direct parent, and the body is no longer a
            // sibling of the header.
            var $item = $(this).closest('.accordion__item');
            var $body = $item.find('.accordion__body').first();
            var isActive = $item.hasClass('active');

            if (isActive) {
                $body.slideToggle();
                $item.toggleClass('active');
            } else {
                var $siblings = $item.siblings();
                $siblings.removeClass('active');
                $siblings.find('.accordion__body').slideUp();
                $siblings.each(function () { syncAria($(this)); });
                $body.slideToggle();
                $item.toggleClass('active');
            }
            syncAria($item);
        });
    },
    send_ring_sizer: function () { 
        $('#send-ring-sizer').click(function(){
            $('.selector--size').val('Send ring sizer');
        });
    }
}

$(document).ready(function () {
    goodstone.init();
});